
export const TELEGRAM = 'https://t.me/MojitoFinance'
export const TWITTER = 'https://twitter.com/MojitoSwap'
export const MEDIUM = 'https://medium.com/@mojitoswap'
export const GITHUB = 'https://github.com/MojitoFinance'
export const DOCS = 'https://docs.mojitoswap.finance'


export const MojitoSwap = {
  FULLNAME: 'MojitoSwap',
  DOCS_URL: DOCS,
  GITHUB_URL: GITHUB,
  MEDIA_URL: MEDIUM,
  TWITTER,
  TELEGRAM,
  cmc: 'https://coinmarketcap.com/currencies/mojitoswap',
  coingecko: 'https://www.coingecko.com/en/coins/mojitoswap',
  defillama: 'https://defillama.com/protocol/mojitoswap',
  applyForFarm: 'https://forms.gle/8pe2yGRXFgK1noWV6',
  applyForIDO: 'https://forms.gle/u4tJXfeX6VdSUdVg8',
  applyForNFT: 'https://forms.gle/9aVShwytCss2Sovb8',
  bugBounty: 'https://forms.gle/9S213wNbgHhhxbGu6',
  CONTACT_LIST: [
    {
      app: 'Twitter',
      icon: require('../assets/images/home/twitter.svg').default,
      hoverIcon: require('../assets/images/icon/twitter.png').default,
      route: TWITTER,
    },
    {
      app: 'Github',
      icon: require('../assets/images/home/github.svg').default,
      hoverIcon: require('../assets/images/icon/github.png').default,
      route: GITHUB,
    },
    {
      app: 'Telegram',
      icon: require('../assets/images/home/tel.svg').default,
      hoverIcon: require('../assets/images/icon/tel.png').default,
      route: TELEGRAM,
    },

    {
      app: 'Mediumn',
      icon: require('../assets/images/home/medium.svg').default,
      hoverIcon: require('../assets/images/icon/medium.png').default,
      route: MEDIUM,
    },
  ],
}

export const APP = {
  TOKEN_INFO_CDN: 'https://cdn.jsdelivr.net/gh/kucoin-community-chain/tokens-info@main/icons/',
}


// footer nanList
export const FOOTER_LIST = [
  {
    title: 'Contract',
    children: [
      {
        navText: 'Apply For Farm',
        navRoute: MojitoSwap.applyForFarm,
      },
      {
        navText: 'Apply For IDO',
        navRoute: MojitoSwap.applyForIDO,
      },
      {
        navText: 'Apply For NFT',
        navRoute: MojitoSwap.applyForNFT,
      },
    ],
  },
  {
    title: 'About',
    children: [
      {
        navText: 'CoinMarketCap',
        navRoute: MojitoSwap.cmc,
      },
      {
        navText: 'CoinGecko',
        navRoute: MojitoSwap.coingecko,
      },
      {
        navText: 'Defillama',
        navRoute: MojitoSwap.defillama,
      },
    ],
  },
  {
    title: 'Help',
    children: [
      {
        navText: 'Docs',
        navRoute: MojitoSwap.DOCS_URL,
      },
      {
        navText: 'Github',
        navRoute: MojitoSwap.GITHUB_URL,
      },
      {
        navText: 'Bug Bounty',
        navRoute: MojitoSwap.bugBounty,
      },
      {
        navText: 'Contact Support',
        navRoute: MojitoSwap.TELEGRAM,
      },
    ],
  },
]
